import React from "react";
import Config from "../services/config";
import { FaHeart } from "react-icons/fa6";
import { HEADER_COLOR } from "../constants/theme";

const Footer = () => {
  return (
    <div
      className="row w-100 mx-auto flex-column align-items-center justify-content-center text-center"
      style={{
        lineHeight: "1",
        gap: "7px",
        padding: "15px 0",
        borderBottom: "1px solid #ffffff",
        borderTop: "1px solid #ffffff",
      }}
    >
      <div className="col-auto p-0">
        <div
          className="d-flex align-items-end justify-content-center"
          style={{
            fontSize: "11px",
            color: HEADER_COLOR,
            fontWeight: "600",
            letterSpacing: "0.04ch",
            // gap: '4px'
          }}
        >
          Digital Custodian{" "}
          {
            <FaHeart
              style={{
                width: "11px",
                height: "11px",
                marginLeft: "7px",
                marginRight: "5px",
                marginBottom: "1.16px",
                overflow: "visible",
              }}
            />
          }{" "}
          {Config.appEnv} - {Config.appVersion}
        </div>
      </div>
    </div>
  );
};

export default Footer;
